module.exports = __webpack_public_path__ + "static/media/react.4f81f37c.svg";